// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"la","red":"ma","calloutlink":"na","headerTopBanner":"oa","bgcolorRed":"pa","headerTopCallout":"qa","searchBanner":"ra","hideMobile":"sa"};